import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import StudentList from "../components/StudentList";


const StudentListPage = () => {
  return (
    <>

        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Students  </h5><Breadcrumb title="Students" /></div>


        <StudentList />

    </>
  );
};


export default StudentListPage;
